import { useMemo } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';

enum Variant {
    Control = 1,
    VariantB = 2,
    VariantC = 3,
    VariantD = 4,
}

export const useExperiment = (experimentId: number) => {
    const { abTests } = getContext();
    const group = Number(abTests[experimentId]); // could be NaN

    return useMemo(
        () => ({
            group: group ? group : undefined,
            unallocated: !(experimentId in abTests),
            inControl: group === Variant.Control,
            inExperiment: group > Variant.Control,
            inGroupB: group === Variant.VariantB,
            inGroupC: group === Variant.VariantC,
            inGroupD: group === Variant.VariantD,
        }),
        [] // eslint-disable-line react-hooks/exhaustive-deps
    );
};
